var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tab"},[_c('div',{staticClass:"content"},_vm._l((_vm.list),function(item,key){return _c('div',{staticClass:"item",class:key === _vm.index ? 'active':''},[_c('div',{staticClass:"name"},[_vm._v(_vm._s(item.name))]),_c('div',{staticClass:"border"})])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }